import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { OrganisationDTO } from "../types/organisationDTO";
import Problem from "../types/problem";
import apiClient from "../main/apiClient";

const useFetchOrganisations = () => {
    return useQuery<OrganisationDTO[], AxiosError>({
        queryKey: ["organisation"],
        queryFn: () =>
          apiClient.get('/organisation/').then((resp) => resp.data)
    });
}

const useFetchOrganisation = (id: string) => {
  return useQuery<OrganisationDTO, AxiosError>({
    queryKey: ["organisation", id],
    queryFn: () =>
      apiClient.get(`/organisation/${id}`).then((resp) => resp.data),
  });
};

const useUpdateOrganisation = () => {
  const queryClient = useQueryClient();
  return useMutation<AxiosResponse, AxiosError<Problem>, OrganisationDTO>({
    mutationFn: (organisationDTO) => apiClient.put(`/organisation`, organisationDTO),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["organisation"] });
    },
    onError: (error) => {
      console.log(error);
    }
  });
};

const useAddOrganisation = (setOrganisationState: (organisation: OrganisationDTO) => void) => {
    const queryClient = useQueryClient();
    return useMutation<AxiosResponse, AxiosError<Problem>, OrganisationDTO>({
      mutationFn: (organisationDTO) => apiClient.post(`/organisation`, organisationDTO),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["organisation"] });
      },
      onError: (error, variables) => {
        console.log(error);
        setOrganisationState(variables); // Preserve the state on error
      }
    });
  };

export { useFetchOrganisations, useAddOrganisation, useFetchOrganisation, useUpdateOrganisation }